<div class="section__header" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource">
  <h2 class="section__header-text" >Add Runway</h2>
  <button id="add_btn" (click)="openAddRunwayDialog(null)" mat-mini-fab *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource">
    <mat-icon aria-label="Add Runway">add</mat-icon>
  </button>
</div>
<div *ngIf="airport.landingSurfaces.length; else na">
  <app-runway-detail
    *ngFor="let runway of sortedLandingSurfaces"
    [airportId]=airport.airportId
    [identifier]=airport.identifier
    [runway]="runway"
    [magVariation]="airport.magVariationValue"
    [remarks]="airport.airportComments"
    [isIslandSource]="isIslandSource"
    [editModeSet]="editModeSet"
    (runwayDeleted)="onRunwayDeleted($event)">
  </app-runway-detail>
</div>
<ng-template #na>
  <h2>Landing Surfaces</h2>
  <span class="overview__na">There are no landing surfaces available at {{airport.identifier}}.</span>
</ng-template>
